import type { SceneMeta } from '@/types';

// 风电机组维护 3D 场景元数据 v1
// 场景定位：兆瓦级风电机组全三维场景 —— 叶片桨距控制 + 齿轮箱温控 + 偏航对风 + 变流器功率调节
// 复用 SceneMeta 通用格式；is3D=true 由 FactoryCanvas 路由到 WindTurbine3D 组件
export const windturbineMeta: SceneMeta = {
  id: 'windturbine',
  name: '风电机组维护',
  shortName: '风电',
  icon: '🌪️',
  thumbnail: '/scenes/windturbine.jpg',
  description: '兆瓦级风电机组全三维场景 · 叶片桨距控制 · 齿轮箱温控 · 偏航对风 · 变流器功率调节',
  // 3D 场景：designSize 仅作为 UI 浮层布局参考，实际 3D 渲染填满父容器
  designSize: { width: 1280, height: 760 },
  primaryColor: '#06b6d4',  // 风电青 —— 与清洁能源/天空颜色一致
  difficulty: 'advanced',
  status: 'available',
  is3D: true,
};
